var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M29.9609 13.7617L18.7324 24.4062L29.9609 35.0508","stroke":_vm.color,"stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }